import { components } from "react-select";

import { formatProductOption } from "./formatProductOption";

export const ProductOption = (props) => <components.Option {...props}>{formatProductOption(props.data)}</components.Option>;

export const ProductSingleValue = (props) => <components.SingleValue {...props}>{formatProductOption(props.data)}</components.SingleValue>;
